import axios from '../teacherLms/adapters/axios';
import { studentApiUrl } from '../teacherLms/adapters/apiUrl';

// Explicit namespace: the shared store also lives outside /lms/question-bank.
export async function requestStudentStore(path, body, onSuccess, onError) {
  try {
    const { data } = await axios.post(studentApiUrl(path), body, { timeout: 20000 });
    onSuccess(data);
  } catch (error) {
    onError?.(error);
  }
}

export async function resolveStudentStoreImage(imagePath) {
  const { data } = await axios.post(studentApiUrl('/get-image-path'), { imagePath, sec: 600 }, { timeout: 20000 });
  return data?.url || '';
}
